import { api } from '@/lib';

export async function getVerifyUsername(username: string) {
  return api
    .get(`/usuario/Usuario-Por-Username?username=${username}`)
    .catch(e => {});
}
